import { render } from "./testimonialTwo.vue?vue&type=template&id=0402dcef"
import script from "./testimonialTwo.vue?vue&type=script&lang=js"
export * from "./testimonialTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__